import React from 'react';
import type { SVGProps } from 'react';
// General Icons
import Agent from './agent.svg';
import AlertCircle from './alert-circle.svg';
import AlertSquare from './alert-square.svg';
import AlertTriangle from './alert-triangle.svg';
import AnnotationQuestion from './annotation-question.svg';
import Announcement from './announcement.svg';
import Apps from './apps.svg';
import Archive from './archive.svg';
import ArrowDown from './arrow-down.svg';
import ArrowRight from './arrow-right.svg';
import ArrowLeft from './arrow-left.svg';
import ArrowUp from './arrow-up.svg';
import ArrowUpRight from './arrow-up-right.svg';
import AuditLog from './audit-log.svg';
import BarChart from './bar-chart.svg';
import BrowserPage from './browser-page.svg';
import Building from './building.svg';
import Calendar from './calendar.svg';
import Check from './check.svg';
import CheckboxChecked from './checkbox-checked.svg';
import CheckboxDone from './checkbox-done.svg';
import CheckboxIndeterminate from './checkbox-indeterminate.svg';
import CheckboxUnchecked from './checkbox-unchecked.svg';
import CheckCircle from './check-circle.svg';
import CheckVerified from './check-verified-01.svg';
import ChevronDown from './chevron-down.svg';
import ChevronUp from './chevron-up.svg';
import ChevronUpDouble from './chevron-up-double.svg';
import ChevronRight from './chevron-right.svg';
import ChevronLeft from './chevron-left.svg';
import ClockSnoozed from './clock-snoozed.svg';
import ClockFastForward from './clock-fast-forward.svg';
import Close from './x-close.svg';
import CloseCircle from './x-circle.svg';
import CodeBrowser from './code-browser.svg';
import CodeSquare from './code-square.svg';
import ComingSoon from './coming-soon.svg';
import Copy from './copy.svg';
import CryptoKey from './crypto-key.svg';
import Cube from './cube.svg';
import CubeOutline from './cube-outline.svg';
import CursorBox from './cursor-box.svg';
import CutCircleYellow from './cut-circle-yellow.svg';
import Dashboard from './dashboard.svg';
import Discover from './discover.svg';
import Documentation from './documentation.svg';
import Dotpoints from './dotpoints.svg';
import DotsHorizontal from './dots-horizontal.svg';
import DotsVertical from './dots-vertical.svg';
import Download from './download.svg';
import EditUser from './edit-user.svg';
import Edit from './edit.svg';
import Eye from './eye.svg';
import EyeOff from './eye-off.svg';
import FileShield from './file-shield.svg';
import Folder from './folder.svg';
import Fingerprint from './fingerprint.svg';
import Globe from './globe.svg';
import Group from './group.svg';
import HighSeverity from './high-severity.svg';
import Human from './human.svg';
import HumanWithNHI from './human-nhi-instances.svg';
import Info from './info.svg';
import InfoSeverity from './info-severity.svg';
import LegoBlock from './lego-block.svg';
import Lightbulb from './lightbulb.svg';
import Lightning from './lightning.svg';
import LinkOut from './link-out.svg';
import Local from './local.svg';
import Lock from './lock.svg';
import LockUnlocked from './lock-unlocked.svg';
import LogOut from './log-out.svg';
import LowSeverity from './low-severity.svg';
import Manage from './manage.svg';
import MediumSeverity from './medium-severity.svg';
import Machine from './machine.svg';
import MagicWand from './magic-wand.svg';
import Monitor from './monitor.svg';
import Moon from './moon.svg';
import MyApps from './my-apps.svg';
import Natoma from './natoma-logo-light.svg';
import NatomaMark from './natoma-mark.svg';
import NonHuman from './non-human.svg';
import OfficeBuilding from './office-building.svg';
import OpenCircle from './open-circle.svg';
import OpenInNew from './open-in-new.svg';
import Paperclip from './paperclip.svg';
import Pencil from './pencil.svg';
import PencilLine from './pencil-line.svg';
import PencilRuler from './pencil-ruler.svg';
import PlayCircle from './play-circle.svg';
import Minus from './minus.svg';
import Plus from './plus.svg';
import PlusCircle from './plus-circle.svg';
import PermissionSet from './permission-set.svg';
import PuzzlePiece from './puzzle-piece.svg';
import Refresh from './refresh.svg';
import Review from './review.svg';
import RingingBell from './ringing-bell.svg';
import Rocket from './rocket.svg';
import Role from './role.svg';
import Rules from './rules.svg';
import Search from './search.svg';
import Send from './send.svg';
import Settings from './settings.svg';
import Skill from './skill.svg';
import Share from './share-07.svg';
import StatusRead from './status-read.svg';
import StopCircle from './stop-circle.svg';
import StopCircleRed from './stop-circle-red.svg';
import Sun from './sun.svg';
import System from './system.svg';
import Tool from './tool.svg';
import Trash from './trash.svg';
import Tunnels from './tunnels.svg';
import Unknown from './unknown.svg';
import UnknownIntegration from './unknown-integration.svg';
import Upload from './upload.svg';
import User from './user-01.svg';
import UserEdit from './user-edit.svg';
import UserPlus from './user-plus.svg';
import UserSquare from './user-square.svg';
import Users from './users.svg';
import UserX from './user-x.svg';
import Webhook from './webhook.svg';
import WebhookWrite from './webhook-write.svg';
import XSquare from './x-square.svg';

// Authenticator Icons
import AccessKey from './access-key.svg';
import APIToken from './api-token.svg';
import Certificate from './certificate.svg';
import ClientSecret from './client-secret.svg';
import KeyPair from './key-pair.svg';
import OAuthGrant from './oauth-grant.svg';
import Password from './password.svg';
import PrivateAccessToken from './pat.svg';
import AppInstallation from './app-installation.svg';

// Scope/permission icons
import ScopeAppRead from './scope-app-read.svg';
import ScopeAppWrite from './scope-app-write.svg';
import ScopeCredRead from './scope-cred-read.svg';
import ScopeCredWrite from './scope-cred-write.svg';
import ScopeGroupRead from './scope-group-read.svg';
import ScopeGroupWrite from './scope-group-write.svg';
import ScopeLogsRead from './scope-logs-read.svg';
import ScopeLogsWrite from './scope-logs-write.svg';
import ScopeMailRead from './scope-mail-read.svg';
import ScopeMailWrite from './scope-mail-write.svg';
import ScopeOrgRead from './scope-org-read.svg';
import ScopeOrgWrite from './scope-org-write.svg';
import ScopePolicyRead from './scope-policy-read.svg';
import ScopePolicyWrite from './scope-policy-write.svg';
import ScopePrivilegeRead from './scope-privilege-read.svg';
import ScopePrivilegeWrite from './scope-privilege-write.svg';
import ScopeProfileRead from './scope-profile-read.svg';
import ScopeProfileWrite from './scope-profile-write.svg';
import ScopeTicketRead from './scope-ticket-read.svg';
import ScopeTicketWrite from './scope-ticket-write.svg';
import ScopeUserRead from './scope-user-read.svg';
import ScopeUserWrite from './scope-user-write.svg';
import ShareLink from './share-link.svg';

// Integration Icons
import AWS from './integrations/aws.svg';
import AWSDark from './integrations/aws-dark.svg';
import AzureAD from './integrations/azure-ad.svg';
import AzureKeyVault from './integrations/azure-kv.svg';
import CrowdStrike from './integrations/crowdstrike.svg';
import Datadog from './integrations/datadog.svg';
import Entra from './integrations/entra.svg';
import GCP from './integrations/gcp.svg';
import GitHub from './integrations/github.svg';
import GitHubDark from './integrations/github-dark.svg';
import GoogleWorkspace from './integrations/google.svg';
import Gmail from './mcp_servers/gmail.svg';
import GoogleCalendar from './mcp_servers/google_calendar.svg';
import GoogleDocs from './mcp_servers/google_docs.svg';
import GoogleDrive from './mcp_servers/google_drive.svg';
import GoogleForms from './mcp_servers/google_forms.svg';
import GoogleSheets from './mcp_servers/google_sheets.svg';
import GoogleSlides from './mcp_servers/google_slides.svg';
import GoogleChat from './mcp_servers/google_chat.svg';
import GooglePeople from './mcp_servers/google_people.svg';
import Jamf from './integrations/jamf.svg';
import Jira from './integrations/jira.svg';
import Elasticsearch from './integrations/elasticsearch.svg';
import OpenTelemetry from './integrations/open_telemetry.svg';
import Okta from './integrations/okta.svg';
import OktaDark from './integrations/okta-dark.svg';
import Salesforce from './integrations/salesforce.svg';
import SentinelOne from './integrations/sentinel-one.svg';
import ServiceNow from './integrations/service-now.svg';
import Slack from './integrations/slack.svg';
import Snowflake from './integrations/snowflake.svg';
import Splunk from './integrations/splunk.svg';
import SplunkDark from './integrations/splunk-dark.svg';

/**
 * MCP Server Icons
 * Excluded here (integrations): GitHub, Okta, Service Now, Slack
 */
import Airweave from './mcp_servers/airweave.svg';
import Airtable from './mcp_servers/airtable.svg';
import Apiiro from './mcp_servers/apiiro.png';
import Amplitude from './mcp_servers/amplitude.svg';
import Asana from './mcp_servers/asana.svg';
import Torii from './mcp_servers/torii.png';
import Ashby from './mcp_servers/ashby.png';
import AzureDevOps from './mcp_servers/azure_devops.svg';
import Box from './mcp_servers/box.svg';
import Brave from './mcp_servers/brave.svg';
import Braze from './mcp_servers/braze.svg';
import BrazeDark from './mcp_servers/braze-dark.svg';
import Bullhorn from './mcp_servers/bullhorn.svg';
import Buildkite from './mcp_servers/buildkite.svg';
import ChromeDevTools from './mcp_servers/chromedevtools.svg';
import CircleCI from './mcp_servers/circleci.svg';
import ClickUp from './mcp_servers/clickup.svg';
import Clojure from './mcp_servers/clojure.svg';
import Checkmarx from './mcp_servers/checkmarx.svg';
import Chembl from './mcp_servers/chembl.png';
import CrowdstrikeMCPIcon from './mcp_servers/crowdstrike.svg';
import CrowdstrikeMCPDarkIcon from './mcp_servers/crowdstrike-dark.svg';
import CyeraDataport from './mcp_servers/cyera_dataport.png';
import Dailymed from './mcp_servers/dailymed.png';
import Databricks from './mcp_servers/databricks.svg';
import DataForSEO from './mcp_servers/dataforseo.svg';
import Dovetail from './mcp_servers/dovetail.svg';
import DovetailDark from './mcp_servers/dovetail-dark.svg';
import Drawio from './mcp_servers/drawio.svg';
import Dropbox from './mcp_servers/dropbox.svg';
import Excalidraw from './mcp_servers/excalidraw.svg';
import Cloudflare from './mcp_servers/cloudflare.svg';
import CloudZero from './mcp_servers/cloudzero.png';
import Context7 from './mcp_servers/context7.jpg';
import Figma from './mcp_servers/figma.svg';
import Firecrawl from './mcp_servers/firecrawl.jpeg';
import Fireflies from './mcp_servers/fireflies.svg';
import Freshservice from './mcp_servers/freshservice.svg';
import Fullstory from './mcp_servers/fullstory.svg';
import Gitlab from './mcp_servers/gitlab.svg';
import Glean from './mcp_servers/glean.svg';
import Gong from './mcp_servers/gong.svg';
import GongDark from './mcp_servers/gong-dark.svg';
import Grafana from './mcp_servers/grafana.svg';
import Graphiti from './mcp_servers/graphiti.svg';
import BigQuery from './mcp_servers/bigquery.svg';
import GenaiToolbox from './mcp_servers/genai_toolbox.png';
import Looker from './mcp_servers/looker.svg';
import Oracle from './mcp_servers/oracle.svg';
import Postgres from './mcp_servers/postgres.svg';
import Greenhouse from './mcp_servers/greenhouse.svg';
import Guidewire from './mcp_servers/guidewire.svg';
import Heroku from './mcp_servers/heroku.png';
import Honeycomb from './mcp_servers/honeycomb.png';
import Hubspot from './mcp_servers/hubspot.svg';
import IncidentIo from './mcp_servers/incidentio.svg';
import IncidentIoDark from './mcp_servers/incidentio-dark.svg';
import Iterable from './mcp_servers/iterable.svg';
import Jenkins from './mcp_servers/jenkins.svg';
import JFrog from './mcp_servers/jfrog.svg';
import Kubernetes from './mcp_servers/kubernetes.svg';
import LaunchDarkly from './mcp_servers/launchdarkly.svg';
import LaunchDarklyDark from './mcp_servers/launchdarkly-dark.svg';
import Linear from './mcp_servers/linear.svg';
import Linx from './mcp_servers/linx.png';
import Lucid from './mcp_servers/lucid.svg';
import LucidDark from './mcp_servers/lucid-dark.svg';
import Microsoft365 from './mcp_servers/microsoft365.svg';
import Miro from './mcp_servers/miro.svg';
import Mixpanel from './mcp_servers/mixpanel.svg';
import MongoDB from './mcp_servers/mongodb.svg';
import MotherDuck from './mcp_servers/motherduck.svg';
import Neon from './mcp_servers/neon.svg';
import NeonDark from './mcp_servers/neon-dark.svg';
import Netsuite from './mcp_servers/netsuite.png';
import NewRelic from './mcp_servers/new_relic.svg';
import Observe from './integrations/observe.svg';
import ObserveDark from './integrations/observe-dark.svg';
import Notebooklm from './mcp_servers/notebooklm.svg';
import Notion from './mcp_servers/notion.svg';
import NotionDark from './mcp_servers/notion-dark.svg';
import PagerDuty from './mcp_servers/pagerduty.svg';
import Perplexity from './mcp_servers/perplexity.svg';
import PerplexityDark from './mcp_servers/perplexity-dark.svg';
import Pinecone from './mcp_servers/pinecone.svg';
import PineconeDark from './mcp_servers/pinecone-dark.svg';
import Playwright from './mcp_servers/playwright.svg';
import PowerBi from './mcp_servers/power_bi.svg';
import Prometheus from './mcp_servers/prometheus.svg';
import Prisma from './mcp_servers/prisma.svg';
import PrismaDark from './mcp_servers/prisma-dark.svg';
import Redis from './mcp_servers/redis.svg';
import RedisDark from './mcp_servers/redis-dark.svg';
import Resend from './mcp_servers/resend.svg';
import ResendDark from './mcp_servers/resend-dark.svg';
import Sailpoint from './mcp_servers/sailpoint.svg';
import Scalr from './mcp_servers/scalr.png';
import Selectstar from './mcp_servers/selectstar.svg';
import SelectstarDark from './mcp_servers/selectstar-dark.svg';
import Semgrep from './mcp_servers/semgrep.png';
import SourcebotDark from './mcp_servers/sourcebot-dark.png';
import SourcebotLight from './mcp_servers/sourcebot.png';
import SpaceliftDark from './mcp_servers/spacelift-dark.jpeg';
import SpaceliftLight from './mcp_servers/spacelift-light.png';
import Spinach from './mcp_servers/spinach.jpeg';
import Square from './mcp_servers/square.svg';
import Statsig from './mcp_servers/statsig.jpeg';
import SquareDark from './mcp_servers/square-dark.svg';
import Stripe from './mcp_servers/stripe.svg';
import StripeDark from './mcp_servers/stripe-dark.svg';
import Subconscious from './mcp_servers/subconscious.png';
import Supabase from './mcp_servers/supabase.svg';
import Supernova from './mcp_servers/supernova.svg';
import SupernovaDark from './mcp_servers/supernova-dark.svg';
import Tableau from './mcp_servers/tableau.svg';
import Teradata from './mcp_servers/teradata.svg';
import Atlassian from './mcp_servers/atlassian.svg';
import Avalara from './mcp_servers/avalara.svg';
import DataHub from './mcp_servers/datahub.svg';
import Intercom from './mcp_servers/intercom.svg';
import MCP from './mcp_servers/mcp.svg';
import Paypal from './mcp_servers/paypal.svg';
import Plaid from './mcp_servers/plaid.svg';
import Pubchem from './mcp_servers/pubchem.svg';
import Pubmed from './mcp_servers/pubmed.svg';
import SentinelOneMCP from './mcp_servers/sentinelone.svg';
import Sentry from './mcp_servers/sentry.svg';
import Sonarqube from './mcp_servers/sonarqube.svg';
import AwsCloudWatch from './mcp_servers/cloudwatch.svg';
import SnowflakeMCP from './mcp_servers/snowflake.svg';
import SplunkMCP from './mcp_servers/splunk.svg';
import Upwind from './mcp_servers/upwind.svg';
import UpwindDark from './mcp_servers/upwind-dark.svg';
import Uspto from './mcp_servers/uspto.png';
import Vega from './mcp_servers/vega.png';
import Workato from './mcp_servers/workato.svg';
import WorkatoDark from './mcp_servers/workato-dark.svg';
import Wrike from './mcp_servers/wrike.svg';
import Zapier from './mcp_servers/zapier.svg';
import ZapierDark from './mcp_servers/zapier-dark.svg';
import Invideo from './mcp_servers/invideo.svg';
import AtlassianDark from './mcp_servers/atlassian-dark.svg';
import IntercomDark from './mcp_servers/intercom-dark.svg';
import LinearDark from './mcp_servers/linear-dark.svg';
import SentryDark from './mcp_servers/sentry-dark.svg';
import SmartBear from './mcp_servers/smartbear.svg';
import Webflow from './mcp_servers/webflow.svg';
import Harness from './mcp_servers/harness.svg';
import HarnessDark from './mcp_servers/harness-dark.svg';
import Zoom from './mcp_servers/zoom.svg';
import ZoomInfo from './mcp_servers/zoominfo.svg';
import StarWars from './mcp_servers/star_wars.svg';
import Wiz from './mcp_servers/wiz.svg';
import WizDark from './mcp_servers/wiz-dark.svg';

/**
 * Agentic AI Icons
 */
import AmazonQDeveloper from './mcp_servers/amazonqdeveloper.svg';
import ChatGPT from './mcp_servers/chatgpt.svg';
import Claude from './mcp_servers/claude.svg';
import Cursor from './mcp_servers/cursor.svg';
import Gemini from './mcp_servers/gemini.svg';
import Kiro from './mcp_servers/kiro.svg';
import MsftCopilot from './mcp_servers/msft_copilot.svg';
import VSCode from './mcp_servers/vscode.svg';
import Windsurf from './mcp_servers/windsurf.svg';
import OpenClaw from './mcp_servers/openclaw.svg';
import Cline from './mcp_servers/cline.svg';
import Codex from './mcp_servers/codex.svg';
import LangChain from './mcp_servers/langchain.svg';
import OpenCode from './mcp_servers/opencode.svg';
import OpenCodeDark from './mcp_servers/opencodedark.svg';

// Activity Type Icons - these are 12x12 base svgs
import SmallCode from './small-code.svg';
import SmallCursorClick from './small-cursor-click.svg';
// Activity Icons
import LineChartUp from './line-chart-up.svg';

/**
 * Natomicon Icon Properties. Height and width must both be provided to take effect.
 */
export type IconProps = {
  height?: number;
  width?: number;
  size?: 'small' | 'medium' | 'large' | 'xlarge';
  color?: string;
  ariaLabel?: string;
};

/**
 * Icon sizes in pixels.
 */
const ICON_SIZES = {
  small: 12,
  medium: 16,
  large: 20,
  xlarge: 24
};

/**
 * Default icon size.
 */
const DEFAULT_ICON_SIZE = 'medium';

const formatProps = ({
  height,
  width,
  size,
  color,
  ariaLabel
}: IconProps): {
  height: number;
  width: number;
  color?: string;
} => {
  const otherProps = {
    ...(color && { color: color }),
    ...(ariaLabel && { 'aria-label': ariaLabel })
  };
  if (height && width) {
    return {
      height: height ?? ICON_SIZES[DEFAULT_ICON_SIZE],
      width: width ?? ICON_SIZES[DEFAULT_ICON_SIZE],
      ...otherProps
    };
  } else if (size) {
    return {
      height: ICON_SIZES[size],
      width: ICON_SIZES[size],
      ...otherProps
    };
  } else {
    return {
      height: ICON_SIZES[DEFAULT_ICON_SIZE],
      width: ICON_SIZES[DEFAULT_ICON_SIZE],
      ...otherProps
    };
  }
};

type IconComponentType =
  | React.ComponentType<SVGProps<SVGElement>>
  | { src: string }
  | string;

const renderIcon = (
  IconComponent: IconComponentType,
  props: IconProps
): React.JSX.Element => {
  // Check if the component is a React component (function or class)
  const isReactComponent = typeof IconComponent === 'function';

  if (isReactComponent) {
    return <IconComponent {...formatProps(props)} />;
  }
  const src =
    typeof IconComponent === 'string' ? IconComponent : IconComponent.src;
  const { height, width } = formatProps(props);
  return (
    <img src={src} height={height} width={width} alt={props.ariaLabel || ''} />
  );
};

export function AccessKeyIcon(props: IconProps) {
  return renderIcon(AccessKey, props);
}

export function AgentIcon(props: IconProps) {
  return renderIcon(Agent, props);
}

export function AlertCircleIcon(props: IconProps) {
  return renderIcon(AlertCircle, props);
}

export function AlertSquareIcon(props: IconProps) {
  return renderIcon(AlertSquare, props);
}

export function AlertTriangleIcon(props: IconProps) {
  return renderIcon(AlertTriangle, props);
}

export function AnnotationQuestionIcon(props: IconProps) {
  return renderIcon(AnnotationQuestion, props);
}

export function AnnouncementIcon(props: IconProps) {
  return renderIcon(Announcement, props);
}

export function AppsIcon(props: IconProps) {
  return renderIcon(Apps, props);
}

export function APITokenIcon(props: IconProps) {
  return renderIcon(APIToken, props);
}

export function ArchiveIcon(props: IconProps) {
  return renderIcon(Archive, props);
}

export function ArrowDownIcon(props: IconProps) {
  return renderIcon(ArrowDown, props);
}

export function ArrowLeftIcon(props: IconProps) {
  return renderIcon(ArrowLeft, props);
}

export function ArrowRightIcon(props: IconProps) {
  return renderIcon(ArrowRight, props);
}

export function ArrowUpIcon(props: IconProps) {
  return renderIcon(ArrowUp, props);
}

export function ArrowUpRightIcon(props: IconProps) {
  return renderIcon(ArrowUpRight, props);
}

export function AuditLogIcon(props: IconProps) {
  return renderIcon(AuditLog, props);
}

export function BarChartIcon(props: IconProps) {
  return renderIcon(BarChart, props);
}

export function BrowserPageIcon(props: IconProps) {
  return renderIcon(BrowserPage, props);
}

export function BuildingIcon(props: IconProps) {
  return renderIcon(Building, props);
}

export function CalendarIcon(props: IconProps) {
  return renderIcon(Calendar, props);
}

export function CertificateIcon(props: IconProps) {
  return renderIcon(Certificate, props);
}

export function CheckIcon(props: IconProps) {
  return renderIcon(Check, props);
}

export function CheckboxCheckedIcon(props: IconProps) {
  return renderIcon(CheckboxChecked, props);
}

export function CheckboxDoneIcon(props: IconProps) {
  return renderIcon(CheckboxDone, props);
}

export function CheckboxIndeterminateIcon(props: IconProps) {
  return renderIcon(CheckboxIndeterminate, props);
}

export function CheckboxUncheckedIcon(props: IconProps) {
  return renderIcon(CheckboxUnchecked, props);
}

export function CheckCircleIcon(props: IconProps) {
  return renderIcon(CheckCircle, props);
}

export function CheckVerifiedIcon(props: IconProps) {
  return renderIcon(CheckVerified, props);
}

export function ChevronDownIcon(props: IconProps) {
  return renderIcon(ChevronDown, props);
}

export function ChevronUpIcon(props: IconProps) {
  return renderIcon(ChevronUp, props);
}

export function ChevronUpDoubleIcon(props: IconProps) {
  return renderIcon(ChevronUpDouble, props);
}

export function ChevronRightIcon(props: IconProps) {
  return renderIcon(ChevronRight, props);
}

export function ChevronLeftIcon(props: IconProps) {
  return renderIcon(ChevronLeft, props);
}

export function ClientSecretIcon(props: IconProps) {
  return renderIcon(ClientSecret, props);
}

export function ClockSnoozedIcon(props: IconProps) {
  return renderIcon(ClockSnoozed, props);
}

export function ClockFastForwardIcon(props: IconProps) {
  return renderIcon(ClockFastForward, props);
}

export function CloseIcon(props: IconProps) {
  return renderIcon(Close, props);
}

export function CloseCircleIcon(props: IconProps) {
  return renderIcon(CloseCircle, props);
}

export function CloudflareIcon(props: IconProps) {
  return renderIcon(Cloudflare, props);
}

export function CodeBrowserIcon(props: IconProps) {
  return renderIcon(CodeBrowser, props);
}

export function CodeSquareIcon(props: IconProps) {
  return renderIcon(CodeSquare, props);
}

export function ComingSoonBackground(props: IconProps) {
  return renderIcon(ComingSoon, props);
}

export function CopyIcon(props: IconProps) {
  return renderIcon(Copy, props);
}

export function CryptoKeyIcon(props: IconProps) {
  return renderIcon(CryptoKey, props);
}

export function CubeIcon(props: IconProps) {
  return renderIcon(Cube, props);
}

export function CubeOutlineIcon(props: IconProps) {
  return renderIcon(CubeOutline, props);
}

export function CursorBoxIcon(props: IconProps) {
  return renderIcon(CursorBox, props);
}

export function CutCircleYellowIcon(props: IconProps) {
  return renderIcon(CutCircleYellow, props);
}

export function DashboardIcon(props: IconProps) {
  return renderIcon(Dashboard, props);
}

export function DatadogIcon(props: IconProps) {
  return renderIcon(Datadog, props);
}

export function DiscoverIcon(props: IconProps) {
  return renderIcon(Discover, props);
}

export function DocumentationIcon(props: IconProps) {
  return renderIcon(Documentation, props);
}

export function DotpointsIcon(props: IconProps) {
  return renderIcon(Dotpoints, props);
}

export function DotsHorizontalIcon(props: IconProps) {
  return renderIcon(DotsHorizontal, props);
}

export function DotsVerticalIcon(props: IconProps) {
  return renderIcon(DotsVertical, props);
}

export function DownloadIcon(props: IconProps) {
  return renderIcon(Download, props);
}

export function EditUserIcon(props: IconProps) {
  return renderIcon(EditUser, props);
}

export function EditIcon(props: IconProps) {
  return renderIcon(Edit, props);
}

export function EyeIcon(props: IconProps) {
  return renderIcon(Eye, props);
}

export function EyeOffIcon(props: IconProps) {
  return renderIcon(EyeOff, props);
}

export function FileShieldIcon(props: IconProps) {
  return renderIcon(FileShield, props);
}

export function FingerprintIcon(props: IconProps) {
  return renderIcon(Fingerprint, props);
}

export function FolderIcon(props: IconProps) {
  return renderIcon(Folder, props);
}

export function GlobeIcon(props: IconProps) {
  return renderIcon(Globe, props);
}

export function HighSeverityIcon(props: IconProps) {
  return renderIcon(HighSeverity, props);
}

export function HumanIcon(props: IconProps) {
  return renderIcon(Human, props);
}

export function HumanWithNHIIcon(props: IconProps) {
  return renderIcon(HumanWithNHI, props);
}

export function InfoIcon(props: IconProps) {
  return renderIcon(Info, props);
}

export function InfoSeverityIcon(props: IconProps) {
  return renderIcon(InfoSeverity, props);
}

export function KeyPairIcon(props: IconProps) {
  return renderIcon(KeyPair, props);
}

export function LegoBlockIcon(props: IconProps) {
  return renderIcon(LegoBlock, props);
}

export function LightbulbIcon(props: IconProps) {
  return renderIcon(Lightbulb, props);
}

export function LightningIcon(props: IconProps) {
  return renderIcon(Lightning, props);
}

export function LinkOutIcon(props: IconProps) {
  return renderIcon(LinkOut, props);
}

export function LocalIcon(props: IconProps) {
  return renderIcon(Local, props);
}

export function LockIcon(props: IconProps) {
  return renderIcon(Lock, props);
}

export function LockUnlockedIcon(props: IconProps) {
  return renderIcon(LockUnlocked, props);
}

export function LogOutIcon(props: IconProps) {
  return renderIcon(LogOut, props);
}

export function LowSeverityIcon(props: IconProps) {
  return renderIcon(LowSeverity, props);
}

export function MachineIcon(props: IconProps) {
  return renderIcon(Machine, props);
}

export function MagicWandIcon(props: IconProps) {
  return renderIcon(MagicWand, props);
}

export function ManageIcon(props: IconProps) {
  return renderIcon(Manage, props);
}

export function MediumSeverityIcon(props: IconProps) {
  return renderIcon(MediumSeverity, props);
}

export function MonitorIcon(props: IconProps) {
  return renderIcon(Monitor, props);
}

export function MoonIcon(props: IconProps) {
  return renderIcon(Moon, props);
}

export function MyAppsIcon(props: IconProps) {
  return renderIcon(MyApps, props);
}

export function NatomaIcon(props: IconProps) {
  return renderIcon(Natoma, props);
}

export function NatomaMarkIcon(props: IconProps) {
  return renderIcon(NatomaMark, props);
}

export function NonHumanIcon(props: IconProps) {
  return renderIcon(NonHuman, props);
}

export function OAuthGrantIcon(props: IconProps) {
  return renderIcon(OAuthGrant, props);
}

export function OfficeBuildingIcon(props: IconProps) {
  return renderIcon(OfficeBuilding, props);
}

export function OpenCircleIcon(props: IconProps) {
  return renderIcon(OpenCircle, props);
}

export function OpenInNewIcon(props: IconProps) {
  return renderIcon(OpenInNew, props);
}

export function PaperclipIcon(props: IconProps) {
  return renderIcon(Paperclip, props);
}

export function PencilIcon(props: IconProps) {
  return renderIcon(Pencil, props);
}

export function PencilLineIcon(props: IconProps) {
  return renderIcon(PencilLine, props);
}

export function PencilRulerIcon(props: IconProps) {
  return renderIcon(PencilRuler, props);
}

export function PlayCircleIcon(props: IconProps) {
  return renderIcon(PlayCircle, props);
}

export function PasswordIcon(props: IconProps) {
  return renderIcon(Password, props);
}

export function PermissionSetIcon(props: IconProps) {
  return renderIcon(PermissionSet, props);
}

export function GroupIcon(props: IconProps) {
  return renderIcon(Group, props);
}

export function PlusCircleIcon(props: IconProps) {
  return renderIcon(PlusCircle, props);
}

export function MinusIcon(props: IconProps) {
  return renderIcon(Minus, props);
}

export function PlusIcon(props: IconProps) {
  return renderIcon(Plus, props);
}

export function PrivateAccessKeyIcon(props: IconProps) {
  return renderIcon(PrivateAccessToken, props);
}

export function PuzzlePieceIcon(props: IconProps) {
  return renderIcon(PuzzlePiece, props);
}

export function RefreshIcon(props: IconProps) {
  return renderIcon(Refresh, props);
}

export function ReviewIcon(props: IconProps) {
  return renderIcon(Review, props);
}

export function RingingBellIcon(props: IconProps) {
  return renderIcon(RingingBell, props);
}

export function RocketIcon(props: IconProps) {
  return renderIcon(Rocket, props);
}

export function RulesIcon(props: IconProps) {
  return renderIcon(Rules, props);
}

export function ScopeAppReadIcon(props: IconProps) {
  return renderIcon(ScopeAppRead, props);
}

export function ScopeAppWriteIcon(props: IconProps) {
  return renderIcon(ScopeAppWrite, props);
}

export function ScopeCredReadIcon(props: IconProps) {
  return renderIcon(ScopeCredRead, props);
}

export function ScopeCredWriteIcon(props: IconProps) {
  return renderIcon(ScopeCredWrite, props);
}

export function ScopeGroupReadIcon(props: IconProps) {
  return renderIcon(ScopeGroupRead, props);
}

export function ScopeGroupWriteIcon(props: IconProps) {
  return renderIcon(ScopeGroupWrite, props);
}

export function ScopeLogsReadIcon(props: IconProps) {
  return renderIcon(ScopeLogsRead, props);
}

export function ScopeLogsWriteIcon(props: IconProps) {
  return renderIcon(ScopeLogsWrite, props);
}

export function ScopeMailReadIcon(props: IconProps) {
  return renderIcon(ScopeMailRead, props);
}

export function ScopeMailWriteIcon(props: IconProps) {
  return renderIcon(ScopeMailWrite, props);
}

export function ScopeOrgReadIcon(props: IconProps) {
  return renderIcon(ScopeOrgRead, props);
}

export function ScopeOrgWriteIcon(props: IconProps) {
  return renderIcon(ScopeOrgWrite, props);
}

export function ScopePolicyReadIcon(props: IconProps) {
  return renderIcon(ScopePolicyRead, props);
}

export function ScopePolicyWriteIcon(props: IconProps) {
  return renderIcon(ScopePolicyWrite, props);
}

export function ScopePrivilegeReadIcon(props: IconProps) {
  return renderIcon(ScopePrivilegeRead, props);
}

export function ScopePrivilegeWriteIcon(props: IconProps) {
  return renderIcon(ScopePrivilegeWrite, props);
}

export function ScopeProfileReadIcon(props: IconProps) {
  return renderIcon(ScopeProfileRead, props);
}

export function ScopeProfileWriteIcon(props: IconProps) {
  return renderIcon(ScopeProfileWrite, props);
}

export function ScopeTicketReadIcon(props: IconProps) {
  return renderIcon(ScopeTicketRead, props);
}

export function ScopeTicketWriteIcon(props: IconProps) {
  return renderIcon(ScopeTicketWrite, props);
}

export function ScopeUserReadIcon(props: IconProps) {
  return renderIcon(ScopeUserRead, props);
}

export function ScopeUserWriteIcon(props: IconProps) {
  return renderIcon(ScopeUserWrite, props);
}

export function ShareLinkIcon(props: IconProps) {
  return renderIcon(ShareLink, props);
}

export function SearchIcon(props: IconProps) {
  return renderIcon(Search, props);
}

export function SendIcon(props: IconProps) {
  return renderIcon(Send, props);
}

export function SettingsIcon(props: IconProps) {
  return renderIcon(Settings, props);
}

export function ShareIcon(props: IconProps) {
  return renderIcon(Share, props);
}

export function SkillIcon(props: IconProps) {
  return renderIcon(Skill, props);
}

export function StatusReadIcon(props: IconProps) {
  return renderIcon(StatusRead, props);
}

export function StopCircleIcon(props: IconProps) {
  return renderIcon(StopCircle, props);
}

export function StopCircleRedIcon(props: IconProps) {
  return renderIcon(StopCircleRed, props);
}

export function SunIcon(props: IconProps) {
  return renderIcon(Sun, props);
}

export function SystemIcon(props: IconProps) {
  return renderIcon(System, props);
}

export function ToolIcon(props: IconProps) {
  return renderIcon(Tool, props);
}

export function TrashIcon(props: IconProps) {
  return renderIcon(Trash, props);
}

export function TunnelsIcon(props: IconProps) {
  return renderIcon(Tunnels, props);
}

export function UnknownIcon(props: IconProps) {
  return renderIcon(Unknown, props);
}

export function UnknownIntegrationIcon(props: IconProps) {
  return renderIcon(UnknownIntegration, props);
}

export function UploadIcon(props: IconProps) {
  return renderIcon(Upload, props);
}

export function UserPlusIcon(props: IconProps) {
  return renderIcon(UserPlus, props);
}

export function UserXIcon(props: IconProps) {
  return renderIcon(UserX, props);
}

export function UserIcon(props: IconProps) {
  return renderIcon(User, props);
}

export function UserEditIcon(props: IconProps) {
  return renderIcon(UserEdit, props);
}

export function UserSquareIcon(props: IconProps) {
  return renderIcon(UserSquare, props);
}

export function UsersIcon(props: IconProps) {
  return renderIcon(Users, props);
}

export function WebhookIcon(props: IconProps) {
  return renderIcon(Webhook, props);
}

export function WebhookWriteIcon(props: IconProps) {
  return renderIcon(WebhookWrite, props);
}

export function XSquareIcon(props: IconProps) {
  return renderIcon(XSquare, props);
}

/** Integration Icons */
export function AWSIcon(props: IconProps) {
  return renderIcon(AWS, props);
}

export function AWSDarkIcon(props: IconProps) {
  return renderIcon(AWSDark, props);
}

export function AzureADIcon(props: IconProps) {
  return renderIcon(AzureAD, props);
}

export function AzureKeyVaultIcon(props: IconProps) {
  return renderIcon(AzureKeyVault, props);
}

export function CrowdStrikeIcon(props: IconProps) {
  return renderIcon(CrowdStrike, props);
}

export function CrowdStrikeMCPIcon(props: IconProps) {
  return renderIcon(CrowdstrikeMCPIcon, props);
}
export function CrowdStrikeMCPDarkIcon(props: IconProps) {
  return renderIcon(CrowdstrikeMCPDarkIcon, props);
}

export function EntraIcon(props: IconProps) {
  return renderIcon(Entra, props);
}

export function GCPIcon(props: IconProps) {
  return renderIcon(GCP, props);
}

export function GitHubIcon(props: IconProps) {
  return renderIcon(GitHub, props);
}

export function GitHubDarkIcon(props: IconProps) {
  return renderIcon(GitHubDark, props);
}

export function GoogleWorkspaceIcon(props: IconProps) {
  return renderIcon(GoogleWorkspace, props);
}

export function GmailIcon(props: IconProps) {
  return renderIcon(Gmail, props);
}

export function GoogleCalendarIcon(props: IconProps) {
  return renderIcon(GoogleCalendar, props);
}

export function GoogleDocsIcon(props: IconProps) {
  return renderIcon(GoogleDocs, props);
}

export function GoogleDriveIcon(props: IconProps) {
  return renderIcon(GoogleDrive, props);
}

export function GoogleFormsIcon(props: IconProps) {
  return renderIcon(GoogleForms, props);
}

export function GoogleSheetsIcon(props: IconProps) {
  return renderIcon(GoogleSheets, props);
}

export function GoogleSlidesIcon(props: IconProps) {
  return renderIcon(GoogleSlides, props);
}

export function GoogleChatIcon(props: IconProps) {
  return renderIcon(GoogleChat, props);
}

export function GooglePeopleIcon(props: IconProps) {
  return renderIcon(GooglePeople, props);
}

export function JamfIcon(props: IconProps) {
  return renderIcon(Jamf, props);
}

export function JiraIcon(props: IconProps) {
  return renderIcon(Jira, props);
}

export function ElasticsearchIcon(props: IconProps) {
  return renderIcon(Elasticsearch, props);
}

export function OpenTelemetryIcon(props: IconProps) {
  return renderIcon(OpenTelemetry, props);
}

export function OktaIcon(props: IconProps) {
  return renderIcon(Okta, props);
}

export function OktaDarkIcon(props: IconProps) {
  return renderIcon(OktaDark, props);
}

export function RoleIcon(props: IconProps) {
  return renderIcon(Role, props);
}

export function SalesforceIcon(props: IconProps) {
  return renderIcon(Salesforce, props);
}

export function SentinelOneIcon(props: IconProps) {
  return renderIcon(SentinelOne, props);
}

export function ServiceNowIcon(props: IconProps) {
  return renderIcon(ServiceNow, props);
}

export function SlackIcon(props: IconProps) {
  return renderIcon(Slack, props);
}

export function SnowflakeIcon(props: IconProps) {
  return renderIcon(Snowflake, props);
}

export function SplunkIcon(props: IconProps) {
  return renderIcon(Splunk, props);
}

export function SplunkDarkIcon(props: IconProps) {
  return renderIcon(SplunkDark, props);
}

export function SmallCodeIcon(props: IconProps) {
  return renderIcon(SmallCode, { ...props, size: 'small' });
}

export function SmallCursorClickIcon(props: IconProps) {
  return renderIcon(SmallCursorClick, { ...props, size: 'small' });
}

export function LineChartUpIcon(props: IconProps) {
  return renderIcon(LineChartUp, props);
}

export function AppInstallationIcon(props: IconProps) {
  return renderIcon(AppInstallation, props);
}

/** MCP Server Icons */

export function AirweaveIcon(props: IconProps) {
  return renderIcon(Airweave, props);
}

export function AirtableIcon(props: IconProps) {
  return renderIcon(Airtable, props);
}

export function AmplitudeIcon(props: IconProps) {
  return renderIcon(Amplitude, props);
}

export function ApiiroIcon(props: IconProps) {
  return renderIcon(Apiiro, props);
}

export function AsanaIcon(props: IconProps) {
  return renderIcon(Asana, props);
}

export function ToriiIcon(props: IconProps) {
  return renderIcon(Torii, props);
}

export function AshbyIcon(props: IconProps) {
  return renderIcon(Ashby, props);
}

export function AzureDevOpsIcon(props: IconProps) {
  return renderIcon(AzureDevOps, props);
}

export function BoxIcon(props: IconProps) {
  return renderIcon(Box, props);
}

export function BraveIcon(props: IconProps) {
  return renderIcon(Brave, props);
}

export function BrazeIcon(props: IconProps) {
  return renderIcon(Braze, props);
}

export function BrazeDarkIcon(props: IconProps) {
  return renderIcon(BrazeDark, props);
}

export function BullhornIcon(props: IconProps) {
  return renderIcon(Bullhorn, props);
}

export function BuildkiteIcon(props: IconProps) {
  return renderIcon(Buildkite, props);
}

export function Context7Icon(props: IconProps) {
  return renderIcon(Context7, props);
}

export function ChromeDevToolsIcon(props: IconProps) {
  return renderIcon(ChromeDevTools, props);
}

export function CircleCIIcon(props: IconProps) {
  return renderIcon(CircleCI, props);
}

export function ClickUpIcon(props: IconProps) {
  return renderIcon(ClickUp, props);
}

export function ClojureIcon(props: IconProps) {
  return renderIcon(Clojure, props);
}

export function CheckmarxIcon(props: IconProps) {
  return renderIcon(Checkmarx, props);
}

export function ChemblIcon(props: IconProps) {
  return renderIcon(Chembl, props);
}

export function CloudZeroIcon(props: IconProps) {
  return renderIcon(CloudZero, props);
}

export function CyeraDataportIcon(props: IconProps) {
  return renderIcon(CyeraDataport, props);
}

export function DailymedIcon(props: IconProps) {
  return renderIcon(Dailymed, props);
}
export function DatabricksIcon(props: IconProps) {
  return renderIcon(Databricks, props);
}

export function DataForSEOIcon(props: IconProps) {
  return renderIcon(DataForSEO, props);
}

export function DovetailIcon(props: IconProps) {
  return renderIcon(Dovetail, props);
}

export function DovetailDarkIcon(props: IconProps) {
  return renderIcon(DovetailDark, props);
}

export function DrawioIcon(props: IconProps) {
  return renderIcon(Drawio, props);
}

export function DropboxIcon(props: IconProps) {
  return renderIcon(Dropbox, props);
}

export function ExcalidrawIcon(props: IconProps) {
  return renderIcon(Excalidraw, props);
}

export function FigmaIcon(props: IconProps) {
  return renderIcon(Figma, props);
}

export function FirecrawlIcon(props: IconProps) {
  return renderIcon(Firecrawl, props);
}

export function FirefliesIcon(props: IconProps) {
  return renderIcon(Fireflies, props);
}

export function FreshserviceIcon(props: IconProps) {
  return renderIcon(Freshservice, props);
}

export function FullstoryIcon(props: IconProps) {
  return renderIcon(Fullstory, props);
}

export function GitLabIcon(props: IconProps) {
  return renderIcon(Gitlab, props);
}

export function GleanIcon(props: IconProps) {
  return renderIcon(Glean, props);
}

export function GongIcon(props: IconProps) {
  return renderIcon(Gong, props);
}

export function GongDarkIcon(props: IconProps) {
  return renderIcon(GongDark, props);
}

export function GrafanaIcon(props: IconProps) {
  return renderIcon(Grafana, props);
}

export function GraphitiIcon(props: IconProps) {
  return renderIcon(Graphiti, props);
}

export function BigQueryIcon(props: IconProps) {
  return renderIcon(BigQuery, props);
}

export function GenaiToolboxIcon(props: IconProps) {
  return renderIcon(GenaiToolbox, props);
}

export function LookerIcon(props: IconProps) {
  return renderIcon(Looker, props);
}

export function OracleIcon(props: IconProps) {
  return renderIcon(Oracle, props);
}

export function PostgresIcon(props: IconProps) {
  return renderIcon(Postgres, props);
}

export function GreenhouseIcon(props: IconProps) {
  return renderIcon(Greenhouse, props);
}

export function GuidewireIcon(props: IconProps) {
  return renderIcon(Guidewire, props);
}

export function HerokuIcon(props: IconProps) {
  return renderIcon(Heroku, props);
}

export function HoneycombIcon(props: IconProps) {
  return renderIcon(Honeycomb, props);
}

export function HubspotIcon(props: IconProps) {
  return renderIcon(Hubspot, props);
}

export function IncidentIoIcon(props: IconProps) {
  return renderIcon(IncidentIo, props);
}

export function IncidentIoDarkIcon(props: IconProps) {
  return renderIcon(IncidentIoDark, props);
}

export function IterableIcon(props: IconProps) {
  return renderIcon(Iterable, props);
}

export function JenkinsIcon(props: IconProps) {
  return renderIcon(Jenkins, props);
}

export function JFrogIcon(props: IconProps) {
  return renderIcon(JFrog, props);
}

export function KubernetesIcon(props: IconProps) {
  return renderIcon(Kubernetes, props);
}

export function LaunchDarklyIcon(props: IconProps) {
  return renderIcon(LaunchDarkly, props);
}

export function LaunchDarklyDarkIcon(props: IconProps) {
  return renderIcon(LaunchDarklyDark, props);
}

export function LinearIcon(props: IconProps) {
  return renderIcon(Linear, props);
}

export function LinearDarkIcon(props: IconProps) {
  return renderIcon(LinearDark, props);
}

export function LinxIcon(props: IconProps) {
  return renderIcon(Linx, props);
}

export function LucidIcon(props: IconProps) {
  return renderIcon(Lucid, props);
}

export function LucidDarkIcon(props: IconProps) {
  return renderIcon(LucidDark, props);
}

export function Microsoft365Icon(props: IconProps) {
  return renderIcon(Microsoft365, props);
}

export function MiroIcon(props: IconProps) {
  return renderIcon(Miro, props);
}

export function MixpanelIcon(props: IconProps) {
  return renderIcon(Mixpanel, props);
}

export function MongoDBIcon(props: IconProps) {
  return renderIcon(MongoDB, props);
}

export function MotherDuckIcon(props: IconProps) {
  return renderIcon(MotherDuck, props);
}

export function NeonIcon(props: IconProps) {
  return renderIcon(Neon, props);
}

export function NeonDarkIcon(props: IconProps) {
  return renderIcon(NeonDark, props);
}

export function NetsuiteIcon(props: IconProps) {
  return renderIcon(Netsuite, props);
}

export function NewRelicIcon(props: IconProps) {
  return renderIcon(NewRelic, props);
}

export function ObserveIcon(props: IconProps) {
  return renderIcon(Observe, props);
}

export function ObserveDarkIcon(props: IconProps) {
  return renderIcon(ObserveDark, props);
}

export function NotebooklmIcon(props: IconProps) {
  return renderIcon(Notebooklm, props);
}

export function NotionIcon(props: IconProps) {
  return renderIcon(Notion, props);
}

export function NotionDarkIcon(props: IconProps) {
  return renderIcon(NotionDark, props);
}

export function PagerDutyIcon(props: IconProps) {
  return renderIcon(PagerDuty, props);
}

export function PerplexityIcon(props: IconProps) {
  return renderIcon(Perplexity, props);
}

export function PerplexityDarkIcon(props: IconProps) {
  return renderIcon(PerplexityDark, props);
}

export function PineconeIcon(props: IconProps) {
  return renderIcon(Pinecone, props);
}

export function PineconeDarkIcon(props: IconProps) {
  return renderIcon(PineconeDark, props);
}

export function PlaywrightIcon(props: IconProps) {
  return renderIcon(Playwright, props);
}

export function PowerBiIcon(props: IconProps) {
  return renderIcon(PowerBi, props);
}

export function PrometheusIcon(props: IconProps) {
  return renderIcon(Prometheus, props);
}

export function PrismaIcon(props: IconProps) {
  return renderIcon(Prisma, props);
}

export function PrismaDarkIcon(props: IconProps) {
  return renderIcon(PrismaDark, props);
}

export function RedisIcon(props: IconProps) {
  return renderIcon(Redis, props);
}

export function RedisDarkIcon(props: IconProps) {
  return renderIcon(RedisDark, props);
}

export function ResendIcon(props: IconProps) {
  return renderIcon(Resend, props);
}

export function ResendDarkIcon(props: IconProps) {
  return renderIcon(ResendDark, props);
}

export function SailpointIcon(props: IconProps) {
  return renderIcon(Sailpoint, props);
}

export function ScalrIcon(props: IconProps) {
  return renderIcon(Scalr, props);
}

export function SelectstarIcon(props: IconProps) {
  return renderIcon(Selectstar, props);
}

export function SelectstarDarkIcon(props: IconProps) {
  return renderIcon(SelectstarDark, props);
}

export function SemgrepIcon(props: IconProps) {
  return renderIcon(Semgrep, props);
}

export function SourcebotIcon(props: IconProps) {
  return renderIcon(SourcebotLight, props);
}

export function SourcebotDarkIcon(props: IconProps) {
  return renderIcon(SourcebotDark, props);
}

export function SpaceliftIcon(props: IconProps) {
  return renderIcon(SpaceliftLight, props);
}

export function SpaceliftDarkIcon(props: IconProps) {
  return renderIcon(SpaceliftDark, props);
}

export function SpinachIcon(props: IconProps) {
  return renderIcon(Spinach, props);
}

export function StatsigIcon(props: IconProps) {
  return renderIcon(Statsig, props);
}

export function SquareIcon(props: IconProps) {
  return renderIcon(Square, props);
}

export function SquareDarkIcon(props: IconProps) {
  return renderIcon(SquareDark, props);
}

export function StripeIcon(props: IconProps) {
  return renderIcon(Stripe, props);
}

export function StripeDarkIcon(props: IconProps) {
  return renderIcon(StripeDark, props);
}
export function SupabaseIcon(props: IconProps) {
  return renderIcon(Supabase, props);
}

export function SupernovaIcon(props: IconProps) {
  return renderIcon(Supernova, props);
}

export function SupernovaDarkIcon(props: IconProps) {
  return renderIcon(SupernovaDark, props);
}

export function TableauIcon(props: IconProps) {
  return renderIcon(Tableau, props);
}

export function TeradataIcon(props: IconProps) {
  return renderIcon(Teradata, props);
}

export function AtlassianIcon(props: IconProps) {
  return renderIcon(Atlassian, props);
}

export function AtlassianDarkIcon(props: IconProps) {
  return renderIcon(AtlassianDark, props);
}

export function AvalaraIcon(props: IconProps) {
  return renderIcon(Avalara, props);
}

export function DataHubIcon(props: IconProps) {
  return renderIcon(DataHub, props);
}

export function IntercomIcon(props: IconProps) {
  return renderIcon(Intercom, props);
}

export function IntercomDarkIcon(props: IconProps) {
  return renderIcon(IntercomDark, props);
}

export function InvideoIcon(props: IconProps) {
  return renderIcon(Invideo, props);
}

export function MCPIcon(props: IconProps) {
  return renderIcon(MCP, props);
}

export function PaypalIcon(props: IconProps) {
  return renderIcon(Paypal, props);
}

export function PlaidIcon(props: IconProps) {
  return renderIcon(Plaid, props);
}

export function PubchemIcon(props: IconProps) {
  return renderIcon(Pubchem, props);
}

export function PubmedIcon(props: IconProps) {
  return renderIcon(Pubmed, props);
}

export function SentinelOneMCPIcon(props: IconProps) {
  return renderIcon(SentinelOneMCP, props);
}

export function SentryIcon(props: IconProps) {
  return renderIcon(Sentry, props);
}

export function SentryDarkIcon(props: IconProps) {
  return renderIcon(SentryDark, props);
}

export function SmartBearIcon(props: IconProps) {
  return renderIcon(SmartBear, props);
}

export function SnowflakeMCPIcon(props: IconProps) {
  return renderIcon(SnowflakeMCP, props);
}

export function SplunkMCPIcon(props: IconProps) {
  return renderIcon(SplunkMCP, props);
}

export function AwsCloudWatchIcon(props: IconProps) {
  return renderIcon(AwsCloudWatch, props);
}

export function SonarqubeIcon(props: IconProps) {
  return renderIcon(Sonarqube, props);
}

export function StarWarsIcon(props: IconProps) {
  return renderIcon(StarWars, props);
}

export function UpwindIcon(props: IconProps) {
  return renderIcon(Upwind, props);
}

export function UpwindDarkIcon(props: IconProps) {
  return renderIcon(UpwindDark, props);
}

export function UsptoIcon(props: IconProps) {
  return renderIcon(Uspto, props);
}

export function VegaIcon(props: IconProps) {
  return renderIcon(Vega, props);
}

export function WebflowIcon(props: IconProps) {
  return renderIcon(Webflow, props);
}

export function WizIcon(props: IconProps) {
  return renderIcon(Wiz, props);
}

export function WizDarkIcon(props: IconProps) {
  return renderIcon(WizDark, props);
}

export function WorkatoIcon(props: IconProps) {
  return renderIcon(Workato, props);
}

export function WorkatoDarkIcon(props: IconProps) {
  return renderIcon(WorkatoDark, props);
}

export function WrikeIcon(props: IconProps) {
  return renderIcon(Wrike, props);
}

export function ZapierIcon(props: IconProps) {
  return renderIcon(Zapier, props);
}

export function ZapierDarkIcon(props: IconProps) {
  return renderIcon(ZapierDark, props);
}

export function ZoomIcon(props: IconProps) {
  return renderIcon(Zoom, props);
}

export function ZoomInfoIcon(props: IconProps) {
  return renderIcon(ZoomInfo, props);
}

/** Agentic AI Icons */
export function AmazonQDeveloperIcon(props: IconProps) {
  return renderIcon(AmazonQDeveloper, props);
}

export function ChatGPTIcon(props: IconProps) {
  return renderIcon(ChatGPT, props);
}

export function ClaudeIcon(props: IconProps) {
  return renderIcon(Claude, props);
}

export function CursorIcon(props: IconProps) {
  return renderIcon(Cursor, props);
}

export function GeminiIcon(props: IconProps) {
  return renderIcon(Gemini, props);
}

export function KiroIcon(props: IconProps) {
  return renderIcon(Kiro, props);
}

export function MsftCopilotIcon(props: IconProps) {
  return renderIcon(MsftCopilot, props);
}

export function VSCodeIcon(props: IconProps) {
  return renderIcon(VSCode, props);
}

export function WindsurfIcon(props: IconProps) {
  return renderIcon(Windsurf, props);
}

export function SubconsciousIcon(props: IconProps) {
  return renderIcon(Subconscious, props);
}

export function OpenClawIcon(props: IconProps) {
  return renderIcon(OpenClaw, props);
}

export function HarnessIcon(props: IconProps) {
  return renderIcon(Harness, props);
}
export function HarnessDarkIcon(props: IconProps) {
  return renderIcon(HarnessDark, props);
}

export function ClineIcon(props: IconProps) {
  return renderIcon(Cline, props);
}

export function LangChainIcon(props: IconProps) {
  return renderIcon(LangChain, props);
}

export function CodexIcon(props: IconProps) {
  return renderIcon(Codex, props);
}

export function OpenCodeIcon(props: IconProps) {
  return renderIcon(OpenCode, props);
}

export function OpenCodeDarkIcon(props: IconProps) {
  return renderIcon(OpenCodeDark, props);
}
